@if (config.currentFields) {
  <div class="main-content-container">
    @if (config.currentFields.blocks) {
      <div class="main-container-body">
        <div class="main-box-shadow app-ui-engine-container">
          <!-- {{config | json}} -->
          <dhs-form [action]="'MODIFY'" [data]="config.defaultFormData" [fieldGroup]="config.currentFields" [config]="config.fromConfig"
            (saveFinished)="onSaveFinished($event)">
          </dhs-form>
        </div>
      </div>
    }
  </div>
}